import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { User } from '../models/user.model';
import { GLOBAL } from './global.service';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  private url:      string;
  private identity: any;
  private token:    string;

  constructor(private _http: HttpClient) {
    this.url = GLOBAL.API.url;
  }

  iniciarSesion: (user: User) => Observable<any> = user => {
    let params = JSON.stringify(user);
    let headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this._http.post(`${this.url}auth/login`, params, { headers: headers });
  }

  getLoggedUser: (userId: string) => Observable<any> = (userId) => {
    let headers = new HttpHeaders().set('Content-Type', 'application/json').set('Authorization', this.getToken());
    return this._http.get(`${this.url}users/${userId}/logged`, { headers: headers });
  }

  addUser: (user: User) => Observable<any> = user => {
    let params = JSON.stringify(user);
    let headers = new HttpHeaders().set('Content-Type', 'application/json').set('Authorization', this.getToken());
    return this._http.post(`${this.url}users`, params, { headers: headers });
  };

  updateUser: (user: User) => Observable<any> = user => {
    let params = JSON.stringify(user);
    let headers = new HttpHeaders().set('Content-Type', 'application/json').set('Authorization', this.getToken());
    return this._http.put(`${this.url}users/${user.id}`, params, { headers: headers });
  };

  deleteUser: (userId: string) => Observable<any> = userId => {
    let headers = new HttpHeaders().set('Content-Type', 'application/json').set('Authorization', this.getToken());
    return this._http.delete(`${this.url}users/${userId}`, { headers: headers });
  };

  getUserById: (userId: string) => Observable<any> = userId => {
    let headers = new HttpHeaders().set('Content-Type', 'application/json').set('Authorization', this.getToken());
    return this._http.get(`${this.url}users/${userId}`, { headers: headers });
  };

  listUsers: () => Observable<any> = () => {
    let headers = new HttpHeaders().set('Content-Type', 'application/json').set('Authorization', this.getToken());
    return this._http.get(`${this.url}users`, { headers: headers })
  };

  getIdentity: () => any = () => {
    let identity2 = JSON.parse(localStorage.getItem('identity'));
    let identity3 = JSON.parse(sessionStorage.getItem('identity'));
    this.identity = identity2 != "undefined" ? identity2 : null;
    if (!this.identity) {
      this.identity = identity3 != "undefined" ? identity3 : null;
    }
    return this.identity;
  }

  getToken: () => string = () => {
    let token2 = JSON.parse(localStorage.getItem('token'));
    let token3 = JSON.parse(sessionStorage.getItem('token'));
    this.token = token2 != "undefined" ? token2 : null;
    if (!this.token) {
      this.token = token3 != "undefined" ? token3 : null;
    }
    return this.token;
  }
}
